import "./_header-logo";
import HeaderProps from "./_header-props.js";
import HeaderMobile from "./_header-mobile";
import HeaderToggles from "./_header-toggles";
import HeaderButtonColors from "./_header-button-colors";
import HeaderBackground from "./_header-background";

class Header {
  constructor() {
    if (HeaderProps.$header) {
      this.init();
    }
  }

  /*
   * setup window and document event listeners
   */
  bindEvents() {
    document.addEventListener("click", (e) => {
      if (!e.target.closest("[data-header]")) {
        HeaderBackground.closeHeader();
      }
    });
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        HeaderBackground.closeHeader();
      }
    });
    window.addEventListener("resize", () => {
      HeaderMobile.toggleHeaderState(HeaderBackground.handleHeaderCollapse);
      const $headerToggles = HeaderProps.$header?.querySelectorAll(
        "[data-header-toggle]",
      );
      $headerToggles?.forEach(($toggle) => {
        if (!!$toggle.dataset.headerToggle) {
          const $transitionList = HeaderProps.$header.querySelector(
            `#${$toggle.dataset.headerToggle}`,
          );
          if ($toggle.dataset.headerToggle === "root-nav") {
            return;
          }
          HeaderToggles.setupCustomDelayValuesForSubMenuToggles(
            $transitionList,
          );
        }
      });
    });
  }

  /*
   * Initializes the header
   * should only be called once
   */
  init() {
    HeaderToggles.setup(HeaderBackground.handleHeaderCollapse);
    HeaderMobile.setup(HeaderBackground.handleHeaderCollapse);
    HeaderButtonColors.setup();
    this.bindEvents();
  }

  /*
   * Static method to setup the header
   * This method is purely to describe to the user that this function class should only have one instance
   */
  static setup() {
    new Header();
  }
}

Header.setup();
export default null;
